<template>
  <table
    class="table b-table b-table-stacked-xs table-bordered table-sm bg-white text-uppercase"
  >
    <tbody>
      <tr>
        <th colspan="4">
          <h5 class="text-center"><b>COMPOSIÇÃO FAMILIAR</b></h5>
        </th>
      </tr>
      <tr>
        <td colspan="4">
          <table
            class="table b-table b-table-stacked-xs table-bordered table-sm bg-white text-uppercase"
          >
            <tr>
              <th>Nome</th>
              <th>Idade</th>
            </tr>
            <tr v-for="familiar in item.familiares">
              <td>{{ familiar.nome_completo }}</td>
              <td>{{ familiar.idade_extenso }}</td>
            </tr>
          </table>
        </td>
      </tr>
    </tbody>
  </table>
</template>

<script>
export default {
  props: ["item"],
};
</script>

<style lang="scss" scoped></style>
